import { transparentize } from 'polished';
import React from 'react';

import type { DsrIconProps } from './wrappers';
import { Svg } from './wrappers';

const Icon = ({
  primaryColor,
  selectedColor,
  selected,
  ...svgProps
}: DsrIconProps): JSX.Element => (
  <Svg viewBox="0 0 24 24" version="1.1" {...svgProps}>
    <title>DSR/icon/restrict:default</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        // eslint-disable-next-line max-len
        d="M 12 19 C 12 15.101562 15.101562 12 19 12 L 19 8.398438 L 13.601562 3 L 6 3 C 5.398438 3 5 3.398438 5 4 L 5 20 C 5 20.601562 5.398438 21 6 21 L 12.300781 21 C 12.101562 20.398438 12 19.699219 12 19 Z M 12 19 "
        fill={selected ? selectedColor : transparentize(0.7, primaryColor)}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 18.5 9 L 13 9 L 13 3.5 Z M 19 16 C 20.699219 16 22 17.300781 22 19 C 22 20.699219 20.699219 22 19 22 C 17.300781 22 16 20.699219 16 19 C 16 17.300781 17.300781 16 19 16 M 19 14 C 16.199219 14 14 16.199219 14 19 C 14 21.800781 16.300781 24 19 24 C 21.699219 24 24 21.699219 24 19 C 24 16.300781 21.800781 14 19 14 Z M 19 14 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        d="M 15.5 21.171875 L 21.226562 15.441406 L 22.640625 16.855469 L 16.914062 22.585938 Z M 15.5 21.171875 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
      <path
        // eslint-disable-next-line max-len
        d="M 12.101562 20 L 6 20 L 6 4 L 13.199219 4 L 18 8.800781 L 18 12.101562 C 18.300781 12.101562 18.699219 12 19 12 C 19.300781 12 19.699219 12 20 12.101562 L 20 8 L 14 2 L 6 2 C 4.898438 2 4 2.898438 4 4 L 4 20 C 4 21.101562 4.898438 22 6 22 L 12.699219 22 C 12.398438 21.398438 12.199219 20.699219 12.101562 20 Z M 12.101562 20 "
        fill={selected ? selectedColor : primaryColor}
        fillRule="nonzero"
      />
    </g>
  </Svg>
);

export default Icon;
